import React from "react";
import { Chip, Typography, Box } from "@mui/material";

export default function Changelog() {
  return (
    <Box>

      


      <Typography variant="h4">Cambios 26/09/2025:</Typography>
      <ul>
        <li>Proveedores:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" /> Agregar cuentas bancarias y direcciones
          </li>
        </ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corregir filtrado y paginado
          </li>
        </ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" /> Implementación de Retenciones
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar nuevo comportamiento al borrar pagos
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corregir layout contrarrecibos
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" /> Poder agregar entradas a catálogo de cuentas contables
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" /> Exportar Excel e imprimir layout
          </li>
        </ul>
        <li>ODC:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Cambiar comportamiento al borrar una ODC a cancelarla
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Cambiar formato PDF
          </li>
        </ul>
        <li>Cotizaciones:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corregir cotización con troquel
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 02/09/2025:</Typography>
      <ul>
        <li>Contrarrecibo:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Cambios a UI
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar reglas de negocio al borrar(cancelar) contrarrecibos
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar lógica para mejor calculo de impuestos
          </li>
        </ul>
        <li>Pagos:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar reglas de negocio al borrar pagos
          </li>
        </ul>
        <li>Importaciones:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar regla de negocio para establecer status inicial
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Modificar listas desplegables de la tabla de importaciones
          </li>
        </ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corregir errores de paginado y filtrado
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 28/08/2025:</Typography>
      <ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Filtro por mes con opción de mostrar contrarrecibos del mes actual
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Botón "Filtro por mes/año" para personalizar la vista
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Programación de pagos con filtros por fecha de creación, fecha de pago y rango de claves
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Cambio de nombre de "exportar" a "exportar/programar"
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Botón de programar pago (deshabilitado cuando status = programado)
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Campo "Cuenta Contable" con autocompletado
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Botón "Agregar Cuenta Contable" para crear nuevas cuentas
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Tipo contrarrecibo "Fletes" usa formulario normal de detalle
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Botón "descargar" cambia a "imprimir" y abre en nueva pestaña
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Al agregar cuenta contable desde contrarrecibos, se asigna automáticamente al proveedor seleccionado
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Mejora en el manejo de consecutivos al borrar contrarrecibos
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Al borrar contrarrecibo, status cambia a cancelado manteniendo consecutivo
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Prevención de duplicación de consecutivos al guardar múltiples veces
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corrección de filtros por proveedor y clave
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Al filtrar, regresa automáticamente a la página 1
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Corrección del filtro de búsqueda por proveedor
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 15/08/2025:</Typography>
      <ul>
        <li>Cotizaciones:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso "Pegue lineal"
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso "Sticker transparente"
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso "Retractilado"
          </li>
          <li>
            <Chip label="Nueva funcionalid ad:" color="success" size="small" />{" "}
            Agregar gráfica dinámica a la hora de generar reporte
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar
            utilidades y comisión de venta en reporte de cotización
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Ya se
            pueden editar y eliminar correctamente componentes de cotización
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 05/08/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar sistema de registro histórico de status
          </li>
        </ul>
        <li>Órdenes de compra de clientes:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Rediseño de tabla
            principal
          </li>
        </ul>
        <li>Nuevo módulo - Órdenes de trabajo:</li>
        <ul>
          <li>
            <Chip label="Nuevo módulo:" color="primary" size="small" /> Agregar
            lista y formulario de órdenes de trabajo
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 18/07/2025:</Typography>
      <ul>
        <li>Producto terminado:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se permiten elegir controles de calidad asociados a un producto
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se permiten crear reportes de calidad
          </li>
        </ul>
        <li>Control de Calidad:</li>
        <ul>
          <li>
            <Chip label="Nuevo módulo:" color="primary" size="small" /> Módulo
            de control de calidad para productos terminados
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 27/06/2025:</Typography>
      <ul>
        <li>Importaciones:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Reestructura
            completa del módulo de importaciones
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Tabla mejorada con AG-Grid para mejor rendimiento
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Edición inline de campos en la tabla
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Dropdowns editables para campos como estado y fracción arancelaria
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Filtros avanzados y ordenamiento mejorado
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Cálculo automático de días restantes con indicadores visuales
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Menú de acciones contextual con opciones de documentos y
            contenedores
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Mejor manejo de
            estados con chips de colores
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Actualización en
            tiempo real de datos
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 17/06/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Reestablecer contraseña
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> El ERP ya puede
            enviar correos electrónicos
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 03/05/2025:</Typography>
      <ul>
        <li>Cotizaciones:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Laminado 2 caras
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Barniz 2 caras
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Calculo empatuetado
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Doblado
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Corte de Carta
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Caja rígida
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Troquel
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 23/05/2025:</Typography>
      <ul>
        <li>Cotizaciones:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Gofrado
          </li>
          <li>
            <Chip label="Corrección:" color="error" size="small" /> Arreglar la
            gráfica de cotización
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 19/05/2025:</Typography>
      <ul>
        <li>Nuevo módulo:</li>
        <ul>
          <li>
            <Chip label="Nuevo módulo:" color="success" size="medium" />{" "}
            Cotizaciones
          </li>
        </ul>
        <li>Nueva funcionalidad:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Crear nueva cotización
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar componente a cotización
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Prensa
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Suaje
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Rompecabezas
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Guillotina
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar proceso a cotización - Empalme
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Visualizar gráfica precio unitario
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 28/04/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Crear componente
            generalizado para el cambio de estatus
          </li>
          <li>
            <Chip label="Nuevo módulo:" color="success" size="medium" />{" "}
            Inventario
          </li>
          <li>
            <Chip label="Nuevo módulo:" color="success" size="medium" />{" "}
            Almacenes
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Asignar permisos
            de almacenes a los usuarios
          </li>
        </ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Utilizar el botón
            de Enter para avanzar entre los campos del formulario
          </li>
        </ul>
        <li>Inventario:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar notas de entrada
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar lista de entradas
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar notas de salida
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Agregar lista de salidas
          </li>
        </ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Postrar progreso
            de entrega
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Actualizar
            diagrama de estatus de ordenes de compra
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Agregar regla de
            negocio para gestionar el estatus de las ordenes de compra en base a
            las entradas
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 7/04/2024:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Ahora se pueden programar tareas
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se modificó la
            capa de reglas de negocio para mejorar la legibilidad de todo el
            código
          </li>
        </ul>
        <li>Producto:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se agregó histórico de precios para el catálogo de productos
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó la
            regla de negocio: Agregar precio al histórico cuando se hace una
            órden de compra de materia prima
          </li>
        </ul>
        <li>Ordenes de compra cliente:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó la
            regla de negocio que liga los envíos de exportaciones a los de las
            órdenes de compra
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó la
            tarea programada para checar si la orden de compra está a tiempo o
            tiene retraso
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se cambió el
            color de los status de las órdenes de compra
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 28/03/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó
            visualización del nombre del archivo seleccionado al subir
            documentos
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se implementó
            validación para mostrar mensaje cuando no se han adjuntado todos los
            archivos
          </li>
        </ul>
        <li>Exportaciones:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            habilitó el filtrado por empresa, factura y pedimento
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó campo
            para número de factura
          </li>
        </ul>
        <li>Importaciones:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se rediseñó la
            presentación visual de los días faltantes para mayor claridad
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 27/03/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se creó un
            sistema generalizado de manejo de errores, se va a migrar cada
            módulo a ese sistema.
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se creó un
            componente general para subir archivos
          </li>
        </ul>
        <li>OC clientes:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se migró al nuevo
            sistema de manejo de errores
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregaron
            nuevas reglas de negocio
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se actualizaron
            los campos existentes
          </li>
        </ul>
        <li>Exportaciones:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se agregó la capacidad de adjuntar archivos a cada exportación
          </li>
        </ul>
        <li>Importaciones:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se cambió al
            nuevo componente general para subir archivos
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 18/03/2025:</Typography>
      <ul>
        <li>General:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se eliminó la
            posibilidad de modificar valores numéricos con la rueda del mouse
          </li>
        </ul>
        <li>Ordenes de compra a Cliente (CPO):</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            separaron las CPO por empresa para mejor organización
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó filtro
            por órdenes completadas y botón para mostrar/ocultar completados
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se redefinió el
            cálculo de "Days until MAD" para mayor precisión
          </li>
        </ul>
        <li>Producto Terminado:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            corrigió la visualización de la lista de producto terminado
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 14/03/2025:</Typography>
      <ul>
        <li>Pagos:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se agregó plantilla PDF para visualización de pagos
          </li>
        </ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            separaron las cuentas de proveedor en la plantilla PDF para mejor
            visualización
          </li>
        </ul>
        <li>Exportaciones:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            corrigió la visualización de datos faltantes en la lista de
            exportaciones
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 13/03/2025:</Typography>
      <ul>
        <li>Cuentas contables:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            corrigió el error al intentar dar de alta una cuenta contable
          </li>
        </ul>
        <li>Productos:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            corrigió problema al elegir tipo de producto donde se mantenía la
            categoría anterior
          </li>
        </ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se actualizó
            formato de plantilla para optimizar espacio
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó nombre
            del proveedor y orden de trabajo a la plantilla
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 11/03/2025:</Typography>
      <ul>
        <li>Ordenes de compra a Cliente:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se agregó
            la generación automática de clave al actualizar una CPO
          </li>
        </ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó soporte
            para unidad "MILLAR" con cálculo automático del precio dividido
            entre 1000
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó campo
            "Tipo de Orden" con soporte para "Materia Prima"
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó
            visualización de Órdenes de Trabajo relacionadas a la OC
          </li>
        </ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó método
            de pago
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se agregó Status
            "Cancelado" y capacidad de cancelar contrarrecibos
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se creó componente especial para tipos contrarrecibo: Teléfono,
            Arrendamiento y Luz
          </li>
          <li>
            <Chip label="Mejora:" color="info" size="small" /> Se implementó
            ordenamiento por clave descendiente y se mejoró el proceso de
            programación
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 07/03/2025:</Typography>
      <ul>
        <li>Exportaciones:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Optimizar
            formulario de exportaciones para soportar múltiples artículos sin
            alentar el sistema
          </li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Arreglar
            error crítico al intentar actualizar una exportación
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 06/03/2025:</Typography>
      <ul>
        <li>Contrarrecibos:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se habilitó la captura de contrarrecibos de meses anteriores dentro
            del año en curso
          </li>
          <li>Se eliminaron ceros iniciales en los montos</li>
          <li>
            Se convirtió el campo de tasa de impuesto a un desplegable con
            opciones de 0%, 8% y 16%
          </li>
        </ul>
        <li>Cuentas contables:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            habilitó la edición del campo "cuentas contables" en el catálogo
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 05/03/2025:</Typography>
      <ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>Se agregó botón de "Aprobar" y se aplicaron reglas de negocio</li>
          <li>Se agregó total en texto en la plantilla</li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se arregló
            error al guardar ODC en algunos casos
          </li>
        </ul>
        <li>Exportaciones:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se arregló
            el error al mostrar los campos desplegables
          </li>
        </ul>
        <li>Ordenes de compra a Cliente:</li>
        <ul>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se arregló
            el guardado de la orden de compra
          </li>
          <li> Se agregó campo DateCode</li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se mejoró
            la visualización del indicador RFID
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 28/02/2025:</Typography>
      <ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>Se agregó la observación dinámica de la orden de compra</li>
        </ul>
        <li>Importaciones:</li>
        <ul>
          <li>
            <Chip label="Cambios:" color="info" size="small" /> Se reestructuró
            el módulo de importaciones
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 27/02/2025:</Typography>
      <ul>
        <li>Contrarrecibo:</li>
        <ul>
          <li>Se agregó botón de exportar a PDF un contrarrecibo</li>
          <li>
            <Chip label="Corrección:" color="warning" size="small" /> Se
            corrigió el formato de las cuentas contables de los contrarrecibos
          </li>
        </ul>
      </ul>

      <Typography variant="h4">Cambios 26/02/2025:</Typography>
      <ul>
        <li>Ordenes de compra:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            La plantilla de ordenes de compra se puede imprimir con o sin costos
          </li>
          <li>
            Detalle ODC - Se puede aprobar y descargar una orden de compra
          </li>
          <li>
            Detalle ODC - Se Cambió el botón de "+" por "Agregar Concepto"{" "}
          </li>
          <li>
            Detalle ODC - El fijó el encabezado de la orden de compra, para que
            se mantenga visible aunque se agreguen muchos conceptos
          </li>
        </ul>
        <li>Proveedores:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />
            Checa si existe el proveedor (por RFC) en otra empresa, y copia sus
            datos al formulario actual
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Info Bancaria de proveedor - Se puede editar y eliminar cuentas
            bancarias de los proveedores
          </li>
        </ul>
        <li>Contrarrecibo:</li>
        <ul>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se puede adjuntar un archivo al contrarrecibo (Factura, Nota de
            recepción y orden de compra)
          </li>
          <li>
            <Chip label="Nueva funcionalidad:" color="success" size="small" />{" "}
            Se creó la plantilla para exportar a PDF un contrarrecibo
          </li>
        </ul>
      </ul>
    </Box>
  );
}
